import React, { useState } from 'react'
import NavButton from '../../components/ul/NavButton'

const AdsNavbar = ({ selectState }) => {
    const [isMenuOpen, setIsMenuOpen] = useState(false);

    const navItems = [
        { to: "/manage/ads/nativeAds/add", name: "Native Ads", state: "nativeads" },
        { to: "/manage/ads/fullScreenAds/add", name: "Full Screen Ads", state: "fsads" },
        { to: "/manage/ads/bannerAds/add", name: "Banner Ads", state: "bannerads" },
        { to: "/manage/ads/openAds/add", name: "Open Ads", state: "openads" },
        { to: "/manage/ads/rewardAds/add", name: "Reward Ads", state: "rewardads" },
        { to: "/manage/ads/rewardFsAds/add", name: "RewardFS Ads", state: "rewardfsads" },
        { to: "/manage/ads/inHouseAds/add", name: "InHouse Ads", state: "inhouseads" },
    ];

    return (
        <nav className="text-main-font w-full p-3 sm:p-4">
            <div className="container">
                {/* Mobile Menu Toggle */}
                <div className="sm:hidden flex justify-end mb-2">
                    <button
                        onClick={() => setIsMenuOpen(!isMenuOpen)}
                        className="text-main-font px-2 py-1 border rounded"
                    >
                        {isMenuOpen ? 'Close' : 'Menu'}
                    </button>
                </div>

                {/* Navigation Menu */}
                <ul className={`
                    ${isMenuOpen ? 'flex' : 'hidden'} 
                    sm:flex 
                    flex-col sm:flex-row 
                    space-y-2 sm:space-y-0 
                    sm:space-x-2 md:space-x-3 lg:space-x-4 
                    items-start sm:items-center
                `}>
                    {navItems.map((item) => (
                        <li key={item.state} className="w-full sm:w-auto">
                            <NavButton
                                to={item.to}
                                btnName={item.name}
                                selectState={selectState === item.state}
                                className="w-full sm:w-auto"
                            />
                        </li>
                    ))}
                </ul>
            </div>
        </nav>
    )
}

export default AdsNavbar